var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"om-audio"},[_c('k-audio',{attrs:{"src":_vm.src,"toggle":_vm.playSwitch},on:{"timeupdate":_vm.timeupdate,"playing":_vm.playing,"pause":_vm.pause}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }